"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(require("./Typography"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Typography/index.js
 ** module id = 359
 ** module chunks = 0
 **/